import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M13.5 4.5a2 2 0 11-4 0 2 2 0 014 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M4 6.5h4.086c.89 0 1.337 1.077.707 1.707L7.54 9.46a1 1 0 000 1.415l3.792 3.793M6 11l-1.5 1.5H1m13-3h-2A1.5 1.5 0 0110.5 8"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 6.75a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 9.75h6.129c1.336 0 2.006 1.616 1.06 2.561l-1.878 1.878a1.5 1.5 0 000 2.122L17 22m-8-5.5l-2.25 2.25H1.5m19.5-4.5h-3A2.25 2.25 0 0115.75 12"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M40.5 13.5a6 6 0 11-12 0 6 6 0 0112 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12 19.5h12.258c2.672 0 4.01 3.232 2.12 5.122l-3.756 3.756a3 3 0 000 4.244L34 44M18 33l-4.5 4.5H3m39-9h-6a4.5 4.5 0 01-4.5-4.5"
  }))
};
export var Runner = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});